import type { PresenceWireItem } from './api-client';

/**
 * Rótulos de presença em linguagem de operação — DOMICÍLIO ÚNICO.
 *
 * N2-23 (noturna 05/Set/2026, cenário D3): o painel da equipe do supervisor mostrava
 * «Atendente **away** · última ação há 1min» — o enum de wire (`online|away|busy|offline`)
 * ia à tela sem tradução, enquanto o menu «SUA PRESENÇA» do topbar dizia «Ausente».
 * Havia 4 mapas locais divergentes (`components/PresenceIndicator`, `Topbar`,
 * `agent-dashboard/TeamCollaborationBand`, e o badge do supervisor que nem traduzia).
 * Agora todos consomem este. Presença é conceito universal de operação — não é
 * setorial, então não é config de tenant.
 */
export type PresenceStatus = PresenceWireItem['status'];

export const PRESENCE_LABELS: Readonly<Record<PresenceStatus, string>> = {
  online: 'Online',
  away: 'Ausente',
  busy: 'Ocupado',
  on_call: 'Em ligação',
  offline: 'Offline',
};

/** Rótulo do status; valor desconhecido degrada honesto para o próprio valor (nunca `undefined`). */
export function presenceLabel(status: string): string {
  return (PRESENCE_LABELS as Record<string, string>)[status] ?? status;
}
